import { render } from "./MobileNav.vue?vue&type=template&id=6463e3d7&scoped=true"
import script from "./MobileNav.vue?vue&type=script&lang=js"
export * from "./MobileNav.vue?vue&type=script&lang=js"

import "./MobileNav.vue?vue&type=style&index=0&id=6463e3d7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6463e3d7"]])

export default __exports__